/**
 * API Configuration Module
 *
 * Single source of truth for all API paths and configuration.
 * All paths are relative - Vite proxy handles actual routing to backend services.
 */

export const API_CONFIG = {
  backend: {
    api: '/api/v1',
    auth: '/auth',
    cable: '/cable',
  },
  aiEngine: {
    base: '/ai',
  },
  defaults: {
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
    },
  },
} as const;

/**
 * Construct API URL with version prefix
 * @param path - API endpoint path (e.g., '/projects', '/chat/sessions')
 * @returns Full relative URL (e.g., '/api/v1/projects')
 */
export function apiUrl(path: string): string {
  return `${API_CONFIG.backend.api}${path}`;
}

/**
 * Construct Auth URL for Devise endpoints
 * @param path - Auth endpoint path (e.g., '/login', '/register')
 * @returns Full relative URL (e.g., '/auth/login')
 */
export function authUrl(path: string): string {
  return `${API_CONFIG.backend.auth}${path}`;
}

/**
 * Construct AI Engine URL
 * @param path - AI endpoint path (e.g., '/chat', '/embeddings')
 * @returns Full relative URL (e.g., '/ai/chat')
 */
export function aiUrl(path: string): string {
  return `${API_CONFIG.aiEngine.base}${path}`;
}
